import axios from 'axios';

import { getToken, getTokenHeader } from '../../screen/auth/action';

import {
  compareProductPricesBetweenTwoStatesUrl,
  convertPrimaryOrderToSecondaryOrderUrl,
  getCompanySuppliersUrl,
  getBenefitFlyers,
  getOrderBookingDetailsForOrderIDUrl,
  getOrderBookingPaginatedUrl,
  getOrderPaginatedUrl,
  getOrdersByOrderBookingIdUrl,
  getPoBaseProductUrl,
  getPurchaseOrderDetailsUrl,
  getSearchProductsUrl,
  sellViaInventoryInvoicingUrl,
  updateDirectPaymentStatusUrl,
  updateOrderDetailsUrl,
  getInvoicesPaginatedUrl,
  getInvoiceDetailedUrl,
  compareProductPricesBetweenTwoPricingGeographyUrl,
} from './APIs/API';

export const getCompanySuppliersAction = async (
  module = 'default',
  params = {},
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    if (params instanceof URLSearchParams) {
      params.append('module', module);
    } else {
      params = new URLSearchParams(params);
      params.append('module', module);
    }
    await axios
      .get(getCompanySuppliersUrl(), {
        ...getTokenHeader(token),
        params: params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateDirectPaymentStatusAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${updateDirectPaymentStatusUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const sellViaInventoryInvoicingAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${sellViaInventoryInvoicingUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const convertPrimaryOrderToSecondaryOrderAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${convertPrimaryOrderToSecondaryOrderUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPoBaseProductAction = async ({ manufacturer_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getPoBaseProductUrl()}?manufacturer_id=${manufacturer_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrderBookingPaginatedAction = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getOrderBookingPaginatedUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrderBookingDetailsForOrderIDAction = async (orderID) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getOrderBookingDetailsForOrderIDUrl()}?id=${orderID}`, {
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrderPaginatedAction = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getOrderPaginatedUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPoOrderDetailsAction = async ({ order_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getPurchaseOrderDetailsUrl()}?order_id=${order_id}`,
        getTokenHeader(token),
      )
      .then(async (response) => {
        return next(response.data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const compareProductPricesBetweenTwoStatesAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${compareProductPricesBetweenTwoStatesUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const compareProductPricesBetweenTwoPricingGeographyAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${compareProductPricesBetweenTwoPricingGeographyUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getSearchProductsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getSearchProductsUrl(), getTokenHeader(token))
      .then(async (response) => {
        return next(response.data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateOrderDetailsAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(updateOrderDetailsUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrdersByOrderBookingIdAction = async ({ order_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getOrdersByOrderBookingIdUrl()}?order_booking_id=${order_id}`,
        getTokenHeader(token),
      )
      .then(async (response) => {
        return next(response.data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getFlyersBasedOnRole = async (company_Value) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getBenefitFlyers()}?manufacturer_id=${company_Value}`,
        getTokenHeader(token),
      )
      .then(async (response) => {
        return next(response.data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getInvoicesPaginatedAction = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getInvoicesPaginatedUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getInvoicedDetailedAction = async ({ invoice_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getInvoiceDetailedUrl()}?invoice_id=${invoice_id}`,
        getTokenHeader(token),
      )
      .then(async (response) => {
        return next(response.data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
